import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./index.scss";
import p11 from "../../../assets/images/p51.png";
import p12 from "../../../assets/images/p52.png";
import p21 from "../../../assets/images/p61.png";
import p22 from "../../../assets/images/p62.png";
import p31 from "../../../assets/images/p71.png";
import p32 from "../../../assets/images/p72.png";
import ProductCard from "../../ProductCard";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ProductService from "../../../services/product";
import { showErrorToaster } from "../../../adminCompenents/listComponents/UI/toaster/error";
const productService = new ProductService();
export const NouveauxProduits = () => {
  const [slidesToShow, setSlidesToShow] = useState(3);
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const loadProducts = async () => {
    setIsLoading(true);
    try {
      const response = await productService.getNouveaux();
      setProducts(
        Array.isArray(response.data) ? response.data : response.data?.data || []
      );
    } catch (error) {
      showErrorToaster("Erreur lors du chargement des produits");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadProducts();
  }, []);
  const sliderRef = useRef(null);
  const handleResize = () => {
    const width = window.innerWidth;
    if (width <= 480) setSlidesToShow(1);
    else if (width <= 768) setSlidesToShow(2);
    else if (width <= 1300) setSlidesToShow(2);
    else setSlidesToShow(3);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShow, // dynamique
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    pauseOnHover: true,
  };
  console.log(products);
  return (
    <div className="temoignage-home ">
      <div className="row  justify-content-center  ">
        <div className="col-lg-3">
          <div className="temoignage-home-title">NOUVEAUX PRODUITS</div>
          <div className="temoignage-home-text">
            Découvrez nos dernières nouveautés, pensées pour une beauté
            naturelle et moderne.
          </div>
          <div className="slider-buttons  mt-5 mb-3 mb-md-0 ">
            <button
              onClick={() => sliderRef.current.slickPrev()}
              className="prev-btn ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="23"
                viewBox="0 0 22 23"
                fill="none">
                <path
                  d="M8.77252 5.93579L3.20836 11.5L8.77252 17.0641"
                  stroke="#5B8C51"
                  stroke-width="1.6"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M18.7917 11.5L3.36419 11.5"
                  stroke="#5B8C51"
                  stroke-width="1.6"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <button
              onClick={() => sliderRef.current.slickNext()}
              className="next-btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="23"
                viewBox="0 0 23 23"
                fill="none">
                <path
                  d="M13.2608 17.0642L18.825 11.5L13.2608 5.93588"
                  stroke="#5B8C51"
                  stroke-width="1.6"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M3.24164 11.5H18.6691"
                  stroke="#5B8C51"
                  stroke-width="1.6"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>{" "}
          <button
            className="btn-plus mt-5 mb-3 d-none  d-md-block"
            onClick={() => {
              navigate("/all-products?type=nouveaux");
              window.scrollTo(0, 0);
            }}>
            Voir Plus
          </button>
        </div>
        <div className="col-lg-9 ">
          <Slider {...settings} ref={sliderRef}>
            {products.map((product) => (
              <ProductCard product={product} />
            ))}
          </Slider>
        </div>
        <button
          className="btn-plus mt-5 mb-3 d-md-none  d-block"
          onClick={() => {
            navigate("/all-products?type=nouveaux");
            window.scrollTo(0, 0);
          }}>
          Voir Plus
        </button>
      </div>
    </div>
  );
};
